<template>
  <div>
    <Modal width="700" title="选择模板" v-model="selectModal" class="template-com-selector-mod">
      <Form inline :label-width="60" ref="searchForm" :model="searchForm" @submit.native.prevent>
        <FormItem label="模板标题">
          <Input v-model="searchForm.title" @on-enter="getData()" placeholder=""/>
        </FormItem>
        <FormItem label="模板类型">
          <Select v-model="searchForm.type" placeholder="" filterable multiple clearable>
            <Option v-for="item in types" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getData()" style="margin-right: 8px">搜索</Button>
          <Button @click="clearSearch">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="error" type="warning" show-icon>获取模板列表失败</Alert>
      <div v-else>
        <Row>
          <Col v-for="item in data" :key="item.id">
            <Card class="container-template">
              <div class="container-template-top">
                <Tag v-for="typeItem in item.type" :key="typeItem.id">{{ typeItem.name }}</Tag>
              </div>
              <div class="container-template-title">
                <span v-on:click="selectOk(item)">{{ item.title }}</span>
              </div>
              <div class="container-template-summary">
                <div class="container-template-summary-content">
                  <article class="context">
                    <span v-if="item.description" v-on:click="selectOk(item)">{{ item.description }}</span>
                    <div v-else style="height: 21px; display: block"></div>
                  </article>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button @click="selectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getContainerTemplates, getContainerTemplateTypes } from '@/api/container/template'

export default {
  name: 'selector',
  data () {
    return {
      searchForm: {
        title: '',
        type: []
      },
      data: [],
      types: [],
      error: false,
      selectModal: false
    }
  },
  created: function () {
    this.getTypes()
  },
  methods: {
    openSelectModal () {
      this.searchForm.title = ''
      this.getData()
      this.selectModal = true
    },
    getData () {
      getContainerTemplates(this.searchForm).then(res => {
        this.data = res.data
        this.error = false
      }).catch(res => {
        console.log(res.response)
        this.error = true
      })
    },
    selectOk (data) {
      this.$emit('selectOk', data)
      this.selectModal = false
    },
    getTypes () {
      getContainerTemplateTypes().then(res => {
        this.types = res.data
      }).catch(res => {
        console.error(res.response)
      })
    },
    clearSearch () {
      this.searchForm = {
        title: '',
        type: []
      }
    }
  }
}
</script>

<style scoped lang="less">
  .template-com-selector-mod{
    .ivu-form+div{
      max-height:460px;
      overflow:auto;
    }
  }
  .container-template {
    margin-bottom: 8px;
    background: #f6f6f6!important;
    .container-template-top {
      position: absolute;
      top: 16px;
      right: 16px;
      span {
        color: #999
      }
    }
    .container-template-title {
      font-size: 20px;
      font-weight: bold;
      span {
        cursor: pointer;
      }
      span:hover {
        color: #108ee9;
      }
    }
    .container-template-summary {
      margin-right: 100px;
      .container-template-summary-content {
        .context {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          span {
            cursor: pointer;
          }
          span:hover {
            color: #108ee9;
          }
        }
      }
    }
  }
</style>
